module.exports = __webpack_public_path__ + "static/media/ot_3.efbe9a97.JPG";